import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { ModalComponent } from '../../reusable-components/modal/modal.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CopyService } from '../../services/copy.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    standalone: false
})
export class FooterComponent implements OnInit {
  content: any;
  urlSafe: SafeResourceUrl;

  constructor(
    public modalService: ModalService,
    private matDialog: MatDialog
  ) {}

  openModal(copy, title, actionButtonText) {
    this.modalService.openModal(copy, title, actionButtonText);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.id = "modal-component-terms";
    //console.log(dialogConfig.data.actionButtonText);
  }

  openModalExternal(url, title, actionButtonText) {
    this.modalService.openModalExternal(url, title, actionButtonText);
  }

  ngOnInit(): void {}


  cookieEnglish(){
    document.querySelector('html')?.setAttribute('lang', 'en');
    (window as any).OneTrust.changeLanguage("en");
    document.getElementById('cookieSettings').click();

  }

  cookieSpanish(){
    document.querySelector('html')?.setAttribute('lang', 'es');
    (window as any).OneTrust.changeLanguage("es");
    document.getElementById('cookieSettings').click();
  }
}
